import type { ReportRow } from 'src/app/core/services/reports-api.service';
import { formatReportDuration } from './report-duration.util';
import { hasOutcomeData } from './report-outcomes.util';

const BASE_HEADERS = ['Agent ID', 'Agent Name', 'Client Name', 'Product Type', 'Total PDs', 'PD Duration'];
const OUTCOME_HEADERS = ['Passed', 'Needs review', 'Failed'];

const count = (value: number | undefined): string => (typeof value === 'number' ? String(value) : '');

/** The export as CSV text. Outcome columns appear only when the data has them, so an older backend's file is unchanged. */
export function buildReportsCsv(rows: ReportRow[]): string {
  const withOutcomes = rows.some(hasOutcomeData);
  const headers = withOutcomes ? [...BASE_HEADERS, ...OUTCOME_HEADERS] : BASE_HEADERS;
  const lines = rows.map((r) => {
    const base = [
      r.agent_id,
      r.agent_name,
      r.client_name,
      r.product_type,
      String(r.total_pds),
      formatReportDuration(r.pd_duration_seconds, r.pd_duration_hours),
    ];
    return withOutcomes ? [...base, count(r.pass_count), count(r.review_count), count(r.fail_count)] : base;
  });
  return [headers, ...lines]
    .map((row) => row.map((c) => `"${String(c).replaceAll('"', '""')}"`).join(','))
    .join('\n');
}
